/**
 * @flow
 * @relayHash 5709419a68a47ee75e27042501c1a30f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LogTabInput = {|
  userId: string,
  tabId?: ?string,
  isV4?: ?boolean,
  clientMutationId?: ?string,
|};
export type LogTabMutationVariables = {|
  input: LogTabInput
|};
export type LogTabMutationResponse = {|
  +logTab: ?{|
    +user: ?{|
      +id: string,
      +heartsUntilNextLevel: ?number,
      +level: ?number,
      +tabs: ?number,
      +tabsToday: ?number,
      +vcCurrent: ?number,
    |}
  |}
|};
export type LogTabMutation = {|
  variables: LogTabMutationVariables,
  response: LogTabMutationResponse,
|};
*/


/*
mutation LogTabMutation(
  $input: LogTabInput!
) {
  logTab(input: $input) {
    user {
      id
      heartsUntilNextLevel
      level
      tabs
      tabsToday
      vcCurrent
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "LogTabInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "logTab",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LogTabPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "heartsUntilNextLevel",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "level",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "tabs",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "tabsToday",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "vcCurrent",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "LogTabMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "LogTabMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "LogTabMutation",
    "id": null,
    "text": "mutation LogTabMutation(\n  $input: LogTabInput!\n) {\n  logTab(input: $input) {\n    user {\n      id\n      heartsUntilNextLevel\n      level\n      tabs\n      tabsToday\n      vcCurrent\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2a59efaca4e64321437a5ccb96753c0a';
module.exports = node;
